import { Extension } from '@tiptap/core';
import { Selection } from '@tiptap/extensions';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import Paragraph from './paragraph';
import LiteralTab from './literal-tab';

const FocusDocumentOnPageClick = Extension.create({
  name: 'focusDocumentOnPageClick',
  addStorage() {
    return { listeners: null };
  },
  onCreate({ editor }) {
    const editorPage = editor.view.dom.closest('.tiptap-editor__page');
    const editorPageContainer = editor.view.dom.closest('.tiptap-editor__page-container');
    this.storage.listeners = new AbortController();
    const { signal } = this.storage.listeners;

    editorPage.addEventListener(
      'click',
      (event) => {
        event.target === editorPage && editor.commands.focus();
      },
      { signal }
    );
    editorPageContainer.addEventListener(
      'click',
      (event) => {
        event.target === editorPageContainer && editor.commands.focus();
      },
      { signal }
    );
  },
  // The page elements outlive the editor when its controller reconnects (e.g. when jquery-modal
  // moves a modal), so listeners left behind would focus a destroyed editor.
  onDestroy() {
    this.storage.listeners?.abort();
  },
});

const baseExtensions = [Document, Text, Paragraph, Selection, LiteralTab, FocusDocumentOnPageClick];

export default baseExtensions;
